import Vue from 'vue';
import App from './App.vue';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import VueI18n from 'vue-i18n';
import router from './router';
import './assets/font.css';

Vue.use(router);
Vue.use(Antd);

Vue.use(Antd);
Vue.use(VueI18n);

const messages = {
  en: {
    aboutUs: 'About us',
    services: 'Services',
    video: 'Video',
    resources: 'Resources',
    team: 'Team',
    testimonials: 'Testimonials',
    contactUs: 'CONTACT US',
    CAPTCHA: 'CAPTCHA',
    atCharlotteAndYou: 'At Charlotte And You, ',
    weWorkClosely: 'we work closely with families, international schools, and medical institutions to provide comprehensive, whole-person services.',
    ourMission: `Specializing in evidence-based pediatric occupational therapy for children from birth to 18 years, our mission is to support your child's development through purposeful play and meaningful engagement.`,
    ourMission2: `By encouraging adaptive responses to everyday challenges, we help build essential neural pathways, keeping your child motivated and eager to learn. We are dedicated to guiding their growth, ensuring they are equipped with the skills needed to thrive in an ever-evolving world.`,
    ourMission3: `We are dedicated to guiding their growth, ensuring they are equipped with the skills needed to thrive in an ever-evolving world.`,
    helpingYourChild: 'Helping',
    playLearnGrowThrive1: 'Your Child',
    playLearnGrowThrive2: 'Play, Learn, Grow,',
    playLearnGrowThrive3: 'and Thrive',
    fineMotorSkills: 'Fine Motor',
    handwriting: 'Handwriting',
    visualPerception: 'Visual Perception',
    visualMotorIntegration: 'Visual Motor Integration',
    selfRegulation: 'Self-Regulation',
    sensoryStrategies: 'Sensory Strategies',
    grossMotorAndBilateralCoordination: 'Gross Motor and Bilateral Coordination',
    executiveFunction: 'Executive Function',
    selfCare: 'Self-Care',
    learningDifficulties: 'Learning Difficulties',
    contactForResources: 'If you would like to receive documents, worksheets, or other related resources for any of these areas, please feel free to contact us. We are here to support you and will be happy to provide the necessary materials.',
    areasTitle: 'Areas We Can Help',
    fineMotorSkillsHard: 'Fine Motor Skills & Handwriting Development ',
    coordinationAndMotorPlanning: 'Coordination & Motor Planning Skills ',
    visualPerceptionAndIntegration: 'Visual Perception & Visual-Motor Integration ',
    selfHelpSkills: 'Self-Help Skills & Daily Living Activities ',
    attentionChallenges: 'Attention Challenges in the Classroom (including diffculty maintaining focus) ',
    sensoryProcessingDifferences: 'Sensory Processing Differences (that affect participation and learning) ',
    selfRegulationDifficulties: 'Self-Regulation Diffculties ',
    executiveFunctionChallenges: 'Executive Function Challenges ',
    learningChallenges: 'Learning Challenges (reading, writing, mathematics) ',
    playAndSocialInteractions: 'Play & Social Interactions (that may differ from typical expectations) ',
    difficultyFollowingInstructions: 'Diffculty Following Instructions and Task Transition',

    servicesWeOffer: 'Services We Offer',
    inSchoolOccupationalTherapyServices: 'In-School',
    occupationalTherapyServices: 'Occupational therapy services',
    teacherInterviews: 'Teacher interviews',
    classroomObservations: 'Classroom observations',
    screeningsAndAssessments: 'Screenings and assessments',
    teacherTraining: 'Teacher training',
    ongoingSupportInSchool: 'Ongoing support within the school to help your child thrive in their learning environment.',
    onSiteInPersonOccupationalTherapyServices: 'On-Site',
    occupationalTherapyServices2: 'Occupational Therapy Services',
    parentInterviews: 'Parent interviews',
    comprehensiveAssessment: 'Comprehensive assessment',
    parentAdvocacyAndTraining: 'Parent advocacy and training',
    supportAtHome: 'Support at home to help your child succeed in their daily routines',
    additionalServices: 'Additional Services',
    academicLearningSupportAndClassroomPerformanceSupport: 'Academic Learning Support and Classroom Performance Support.',
    charlotteQiu: 'Charlotte Qiu',
    msotOtr: 'MSOT, OTR',
    nationallyBoardCertifiedOccupationalTherapist: 'Nationally Board-Certified Occupational Therapist (United States)',
    certifiedRehabilitationTherapist: 'Certified Rehabilitation Therapist (China\'s National Health Commission)',
    member: 'Member:',
    americanOccupationalTherapyAssociation: 'American Occupational Therapy Association',
    worldFederationOfOccupationalTherapists: 'World Federation of Occupational Therapists',
    chineseAssociationOfRehabilitationMedicine: 'Chinese Association of Rehabilitation Medicine',
    charlotteProfileDescription1: 'Charlotte Qiu is a highly qualified occupational therapist, registered in the United States and certified in China, reflecting her commitment to meeting international standards of care. She holds both a bachelor\'s and a master\'s degree in occupational therapy, further demonstrating her extensive knowledge in the field.',
    charlotteProfileDescription2: 'Charlotte is certified in DIR Floortime, a child-led, play-based approach to therapy, and holds a USC Sensory Integration certification, allowing her to effectively address sensory processing challenges. With extensive experience as a senior occupational therapist in a pediatric outpatient clinic, Charlotte has developed a deep understanding of child development and therapeutic interventions.',
    charlotteProfileDescription3: 'Through her collaborations with international schools, Charlotte has refined her skills in delivering early intervention and school-based services. By integrating evidence-based, play-based approaches with personalized learning strategies, she consistently enhances students\' learning outcomes and promotes their overall development.',
    charlotteProfileDescription4: 'Charlotte specializes in assessing and supporting children with sensory processing differences, developmental delays, executive function challenges, learning differences, ASD, and ADHD. She excels at working closely with teachers and caregivers to create individualized plans that help children succeed in various settings.',
    whatOurCustomersAreSayingAboutUs: 'What Our Customers are Saying About Us',
    contactUsTitle: 'Contact Us',
    contactUsDescription: 'We\'re here to support your child\'s journey toward growth and success. Whether you\'re looking for guidance, have a question, or are ready to begin services, reaching out is easy. Let’s connect!',
    reachOutTitle: 'Reach Out to Us',

    nameLabel: 'Name',
    emailLabel: 'Email',
    concernLabel: 'Concern',
    submitButton: 'Submit'
    // 其他英文翻译内容
  },
  cn: {
    aboutUs: '关于我们',
    services: '服务项目',
    video: '视频展示',
    resources: 'OT资源',
    team: '团队介绍',
    testimonials: '业界口碑',
    contactUs: '联系我们',
    CAPTCHA: '人机验证',
    atCharlotteAndYouCn: '夏洛与你，',
    weWorkCloselyCn: '我们与国内家庭、国际学校及医疗机构密切合作，提供全方位的、全人发展的服务。',
    ourMissionCn: `专注于0至18岁儿童的循证职能治疗，我们的使命是通过富有意义的游戏与互动，促进孩子的全面成长。通过鼓励孩子应对日常挑战并作出适应性反应，我们帮助他们建立关键的神经通路，激发学习热情，保持积极动机。我们致力于引领孩子的成长，确保他们具备在瞬息万变的世界中茁壮成长所需的能力。`,
    helpingYourChildCn: '孩子的成长，',
    playLearnGrowThriveCn1: '如晨曦初露，',
    playLearnGrowThriveCn2: '在',
    playLearnGrowThriveCn3: '玩乐',
    playLearnGrowThriveCn4: '中学习，',
    playLearnGrowThriveCn6: '努力',
    playLearnGrowThriveCn7: '中飞翔，',
    playLearnGrowThriveCn8: '一步一成长，',
    playLearnGrowThriveCn9: '逐梦远航。',
    otResources: 'OT资源',
    fineMotorSkills: '精细运动',
    handwriting: '书写',
    visualPerception: '视觉感知',
    visualMotorIntegration: '视觉运动整合',
    selfRegulation: '自我调节',
    sensoryStrategies: '感觉策略',
    grossMotorAndBilateralCoordination: '大运动和双侧协调',
    executiveFunction: '执行功能',
    selfCare: '生活自理',
    learningDifficulties: '学习困难',
    contactForResources: '*如果您需要相关领域的文件或相关资源，欢迎随时与我们联系。我们将竭诚为您提供支持，并乐意为您提供所需的材料。',
    areasTitle: '我们可以帮助的领域',
    fineMotorSkillsHard: '精细运动技能和书写发展',
    coordinationAndMotorPlanning: '协调和动作计划能力',
    visualPerceptionAndIntegration: '视觉感知和视觉运动整合',
    selfHelpSkills: '自理能力和日常生活活动',
    attentionChallenges: '课堂注意力困难（包括难以保持专注）',
    sensoryProcessingDifferences: '感觉处理困难（影响活动参与和学习）',
    selfRegulationDifficulties: '自我调节困难',
    executiveFunctionChallenges: '执行功能挑战',
    learningChallenges: '学习困难（阅读、写作、数学）',
    playAndSocialInteractions: '游戏和社交互动（与预期的典型表现不同）',
    difficultyFollowingInstructions: '难以遵循指示和任务切换',
    servicesWeOffer: '我们提供的服务',
    inSchoolOccupationalTherapyServices: '入校服务',
    occupationalTherapyServices: '1对1职能治疗服务',
    teacherInterviews: '教师访谈',
    classroomObservations: '课堂观察',
    screeningsAndAssessments: '筛查和评估',
    teacherTraining: '教师培训',
    ongoingSupportInSchool: '学校内部持续提供支持以帮助孩子在学习环境中茁壮成长。',
    onSiteInPersonOccupationalTherapyServices: '工作室服务',
    occupationalTherapyServices2: '1对1职能治疗服务',
    parentInterviews: '家长访谈',
    comprehensiveAssessment: '全面评估',
    parentAdvocacyAndTraining: '家长宣教和培训',
    supportAtHome: '提供家长在家引导孩子的策略，帮助孩子在他们的日常生活中取得成功',
    additionalServices: '其他服务',
    academicLearningSupportAndClassroomPerformanceSupport: '提供学习支持和课堂表现支持，旨在帮助学生提升学业能力和课堂表现。',
    charlotteQiu: 'Charlotte Qiu',
    msotOtr: '职能治疗硕士,',
    msotOtr1: ' 美国注册职能治疗师',
    nationallyBoardCertifiedOccupationalTherapist: '美国国家注册认证的职能治疗师',
    certifiedRehabilitationTherapist: '中国国家卫生健康委员会认证康复治疗师',
    member: '协会成员:',
    americanOccupationalTherapyAssociation: '美国职能治疗协会',
    worldFederationOfOccupationalTherapists: '世界职能治疗师联合会',
    chineseAssociationOfRehabilitationMedicine: '中国康复医学会',
    charlotteProfileDescription1: 'Charlotte是一位资深且高度专业的职能治疗师，她同时具有美国注册认证并在中国获得认证，体现了她致力于遵循国际循证医学标准。她持有职能治疗学士和硕士学位，进一步展现了她在该领域的深厚学术背景和广泛知识。',
    charlotteProfileDescription2: 'Charlotte获得了DIR Floortime认证，这是一种儿童主导的基于游戏的治疗方法，并持有南加州大学感觉统合认证，使她能够有效地应对感觉处理挑战。凭借在儿科门诊的丰富经验，Charlotte在儿童发展和治疗干预方面积累了深刻的专业理解和经验。Charlotte有过多年的入校与国际学校紧密合作的经验，为很多孩子提供了早期干预和校园治疗服务。',
    charlotteProfileDescription3: 'Charlotte融合了循证医学以及游戏疗法与个性化学习策略，以此来提高学生的学习成绩，促进他们的全面发展。',
    charlotteProfileDescription4: 'Charlotte擅长评估和支持面临感觉处理能力困难、发育迟缓、执行功能挑战、学习困难，ASD和ADHD等挑战的孩子。Charlotte与教师和家长紧密合作，制定个性化的治疗方案，帮助孩子在家庭，学校和社区取得成功。',
    whatOurCustomersAreSayingAboutUs: '客户对我们的评价',
    contactUsTitle: '联系我们',
    contactUsDescription: '我们致力于支持您的孩子在成长与成功的道路上迈出每一步。无论您需要咨询、解答疑问，还是准备开始我们的服务，与我们联系都非常便捷。期待与您携手合作，共同助力孩子的成长！',
    reachOutTitle: '联系我们',
    nameLabel: '姓名',
    emailLabel: '邮箱',
    concernLabel: '问题描述',
    submitButton: '提交'
    // 其他中文翻译内容
  }
};

const i18n = new VueI18n({
  locale: 'en', // 设置默认语言为英文
  messages
});

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app');